import { render, staticRenderFns } from "./ArchivesTable.vue?vue&type=template&id=3aee2aed&scoped=true&"
import script from "./ArchivesTable.vue?vue&type=script&lang=js&"
export * from "./ArchivesTable.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesTable.vue?vue&type=style&index=0&id=3aee2aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee2aed",
  null
  
)

export default component.exports